// Available column colors with display labels and hex values
export const COLUMN_COLOR_OPTIONS = [
  { value: '--neutral-foreground', label: 'Neutral', color: '#6b7280' },
  { value: '--info', label: 'Info', color: '#3b82f6' },
  { value: '--warning', label: 'Warning', color: '#f59e0b' },
  { value: '--success', label: 'Success', color: '#22c55e' },
  { value: '--destructive', label: 'Destructive', color: '#ef4444' },
  // Additional diverse colors
  { value: 'slate', label: 'Slate', color: '#475569' },
  { value: 'zinc', label: 'Zinc', color: '#3f3f46' },
  { value: 'stone', label: 'Stone', color: '#57534e' },
  { value: 'red', label: 'Red', color: '#dc2626' },
  { value: 'orange', label: 'Orange', color: '#ea580c' },
  { value: 'amber', label: 'Amber', color: '#d97706' },
  { value: 'yellow', label: 'Yellow', color: '#ca8a04' },
  { value: 'lime', label: 'Lime', color: '#65a30d' },
  { value: 'green', label: 'Green', color: '#16a34a' },
  { value: 'emerald', label: 'Emerald', color: '#059669' },
  { value: 'teal', label: 'Teal', color: '#14b8a6' },
  { value: 'cyan', label: 'Cyan', color: '#06b6d4' },
  { value: 'sky', label: 'Sky', color: '#0284c7' },
  { value: 'blue', label: 'Blue', color: '#2563eb' },
  { value: 'indigo', label: 'Indigo', color: '#4f46e5' },
  { value: 'violet', label: 'Violet', color: '#7c3aed' },
  { value: 'purple', label: 'Purple', color: '#9333ea' },
  { value: 'fuchsia', label: 'Fuchsia', color: '#c026d3' },
  { value: 'pink', label: 'Pink', color: '#db2777' },
  { value: 'rose', label: 'Rose', color: '#e11d48' },
];

// Mapping from color value/name to hex for quick lookup
export const COLUMN_COLORS_MAP: Record<string, string> = Object.fromEntries(
  COLUMN_COLOR_OPTIONS.map((opt) => [opt.value, opt.color])
);

// Resolve a color value/name to hex, fallback to passed value or default gray
export function resolveColumnColor(color: string): string {
  return COLUMN_COLORS_MAP[color] || color || '#6b7280';
}